var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DiyPage',{attrs:{"page-type":"page","page-id":_vm.$devOrProd(
      '8aaa8c0b86b5a4550186b5f56c15014b',
      '8aaaf6f286dde1b90186ddf19b0f0004'
    )}})}
var staticRenderFns = []

export { render, staticRenderFns }